import React from "react";
import styled from "styled-components";
import SearchBar from "../../common/Search/SearchBar";

const HeaderBar = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  padding: 12px 40px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 12px;
`;

const Title = styled.div`
  margin-right: 60px;
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 20px;
  font-weight: 500;
`;

const EditarContaHeader = () => (
  <HeaderBar>
    <TitleGroup>
      <Title>
        Gerenciamento de Conta
      </Title>
    </TitleGroup>
    <SearchBar style={{ marginRight: "37px" }} />
  </HeaderBar>
);

export default EditarContaHeader;

